"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = _interopRequireDefault(require("./Input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var onChange = function onChange(event) {
  var val = event.target.value;

  if (event.target.validity.valid) {
    onChange(val);
  } else if (val === "" || val === "-") {
    onChange(val);
  } else if (val === ".") {
    onChange("0".concat(val));
  }
};

var onBlur = function onBlur(event) {
  if (event.target.value === "-" || event.target.value === ".") onChange(null);else if (event.target.value === "-0" || event.target.value === "+0") onChange("0");
};

var CurrencyInput = function CurrencyInput(_ref) {
  var name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      disabled = _ref.disabled;
  return _react["default"].createElement("div", {
    className: "input-group"
  }, _react["default"].createElement("div", {
    className: "input-group-prepend"
  }, _react["default"].createElement("span", {
    className: "input-group-text"
  }, "$")), _react["default"].createElement(_Input["default"], {
    id: name,
    onChange: onChange,
    onBlur: onBlur,
    value: value === null ? "" : value,
    pattern: "^-?[0-9]\\d*\\.?\\d*$",
    disabled: disabled
  }));
};

CurrencyInput.propTypes = {
  /** value to pass */
  value: _propTypes["default"].any.isRequired,

  /** on change callback */
  onChange: _propTypes["default"].func.isRequired,

  /** name of the input */
  name: _propTypes["default"].string,

  /** if the input is disabled */
  disabled: _propTypes["default"].bool
};
CurrencyInput.defaultProps = {
  className: "",
  name: "best-currency-input",
  disabled: false
};
var _default = CurrencyInput;
exports["default"] = _default;